(function(){
  "use strict";

  angular.module('eclipseApp.core').controller('exchangeHardwareCtrl', ['$scope', '$injector', '$modalInstance', 'commonService', function ($scope, $injector, $modalInstance, commonService) {
    $scope.store = {};
    $scope.pagination = false;
    $scope.searchCategories = ['Eclipse_Sales'];
    $scope.showSearchCategory = false;
    if(commonService.accountDetails && commonService.accountDetails.length > 0){
      if(commonService.accountDetails[0].subscriberServices && commonService.accountDetails[0].subscriberServices.length > 0 && commonService.accountDetails[0].subscriberServices[0].internet && commonService.accountDetails[0].subscriberServices[0].serviceAddress){
        var internetSubscriberAddress = commonService.accountDetails[0].subscriberServices[0].serviceAddress;
        //$scope.searchLocation = internetSubscriberAddress.streetNumber + ' ' + internetSubscriberAddress.streetName + ' ' + internetSubscriberAddress.city + ', ' + internetSubscriberAddress.province;
        $scope.searchLocation = internetSubscriberAddress.postalCode;
      }
    }
    $scope.ok = function () {
      $modalInstance.close();
    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

  }]);

})();
